import { fetchOneAccountingConnection, saveAccountingConnection, saveManyAccountingConnections, removeAccountingConnection, restoreAccountingConnection } from './accountingConnectionSagas';
import { fetchOneActivityCategory, saveActivityCategory, saveManyActivityCategories, removeActivityCategory, restoreActivityCategory } from './activityCategorySagas';
import { fetchOneActivityType, saveActivityType, saveManyActivityTypes, removeActivityType, restoreActivityType } from './activityTypeSagas';
import { fetchOneAddress, saveAddress, saveManyAddresses, removeAddress, restoreAddress } from './addressSagas';
import { fetchOneAnswer, saveAnswer, saveManyAnswers, removeAnswer, restoreAnswer } from './answerSagas';
import { fetchOneBankAccount, saveBankAccount, saveManyBankAccounts, removeBankAccount, restoreBankAccount } from './bankAccountSagas';
import { fetchOneBlackout, saveBlackout, saveManyBlackouts, removeBlackout, restoreBlackout } from './blackoutSagas';
import { fetchOneCampaign, saveCampaign, saveManyCampaigns, removeCampaign, restoreCampaign } from './campaignSagas';
import { fetchOneCaseType, saveCaseType, saveManyCaseTypes, removeCaseType, restoreCaseType } from './caseTypeSagas';
import { fetchOneCaseTypeStage, saveCaseTypeStage, saveManyCaseTypeStages, removeCaseTypeStage, restoreCaseTypeStage } from './caseTypeStageSagas';
import { fetchOneCategory, saveCategory, saveManyCategories, removeCategory, restoreCategory } from './categorySagas';
import { fetchOneComment, saveComment, saveManyComments, removeComment, restoreComment } from './commentSagas';
import { fetchOneConflict, saveConflict, saveManyConflicts, removeConflict, restoreConflict } from './conflictSagas';
import { fetchOneContact, saveContact, saveManyContacts, removeContact, restoreContact } from './contactSagas';
import { fetchOneCourt, saveCourt, saveManyCourts, removeCourt, restoreCourt } from './courtSagas';
import { fetchOneCourtDeadlineRule, saveCourtDeadlineRule, saveManyCourtDeadlineRules, removeCourtDeadlineRule, restoreCourtDeadlineRule } from './courtDeadlineRuleSagas';
import { fetchOneDeadline, saveDeadline, saveManyDeadlines, removeDeadline, restoreDeadline } from './deadlineSagas';
import { fetchOneDeadlineRule, saveDeadlineRule, saveManyDeadlineRules, removeDeadlineRule, restoreDeadlineRule } from './deadlineRuleSagas';
import { fetchOneDiscount, saveDiscount, saveManyDiscounts, removeDiscount, restoreDiscount } from './discountSagas';
import { fetchOneDocket, saveDocket, saveManyDockets, removeDocket, restoreDocket } from './docketSagas';
import { fetchOneDocument, saveDocument, saveManyDocuments, removeDocument, restoreDocument } from './documentSagas';
import { fetchOneEntityTimestamp, saveEntityTimestamp, saveManyEntityTimestamps, removeEntityTimestamp, restoreEntityTimestamp } from './entityTimestampSagas';
import { fetchOneEvent, saveEvent, saveManyEvents, removeEvent, restoreEvent } from './eventSagas';
import { fetchOneExpense, saveExpense, saveManyExpenses, removeExpense, restoreExpense } from './expenseSagas';
import { fetchOneFirm, saveFirm, saveManyFirms, removeFirm, restoreFirm } from './firmSagas';
import { fetchOneFlatFee, saveFlatFee, saveManyFlatFees, removeFlatFee, restoreFlatFee } from './flatFeeSagas';
import { fetchOneFlatFeeMilestone, saveFlatFeeMilestone, saveManyFlatFeeMilestones, removeFlatFeeMilestone, restoreFlatFeeMilestone } from './flatFeeMilestoneSagas';
import { fetchOneGroup, saveGroup, saveManyGroups, removeGroup, restoreGroup } from './groupSagas';
import { fetchOneHolidayCalendar, saveHolidayCalendar, saveManyHolidayCalendars, removeHolidayCalendar, restoreHolidayCalendar } from './holidayCalendarSagas';
import { fetchOneIdentification, saveIdentification, saveManyIdentifications, removeIdentification, restoreIdentification } from './identificationSagas';
import { fetchOneImportExport, saveImportExport, saveManyImportExports, removeImportExport, restoreImportExport } from './importExportSagas';
import { fetchOneImportSource, saveImportSource, saveManyImportSources, removeImportSource, restoreImportSource } from './importSourceSagas';
import { fetchOneInvoice, saveInvoice, saveManyInvoices, removeInvoice, restoreInvoice } from './invoiceSagas';
import { fetchOneInvoiceBatch, saveInvoiceBatch, saveManyInvoiceBatches, removeInvoiceBatch, restoreInvoiceBatch } from './invoiceBatchSagas';
import { fetchOneInvoiceBatchItem, saveInvoiceBatchItem, saveManyInvoiceBatchItems, removeInvoiceBatchItem, restoreInvoiceBatchItem } from './invoiceBatchItemSagas';
import { fetchOneLead, saveLead, saveManyLeads, removeLead, restoreLead } from './leadSagas';
import { fetchOneLookup, saveLookup, saveManyLookups, removeLookup, restoreLookup } from './lookupSagas';
import { fetchOneMatter, saveMatter, saveManyMatters, removeMatter, restoreMatter } from './matterSagas';
import { fetchOneMatterStage, saveMatterStage, saveManyMatterStages, removeMatterStage, restoreMatterStage } from './matterStageSagas';
import { fetchOneMilestone, saveMilestone, saveManyMilestones, removeMilestone, restoreMilestone } from './milestoneSagas';
import { fetchOneOption, saveOption, saveManyOptions, removeOption, restoreOption } from './optionSagas';
import { fetchOneParticipant, saveParticipant, saveManyParticipants, removeParticipant, restoreParticipant } from './participantSagas';
import { fetchOnePrivilege, savePrivilege, saveManyPrivileges, removePrivilege, restorePrivilege } from './privilegeSagas';
import { fetchOneQuestion, saveQuestion, saveManyQuestions, removeQuestion, restoreQuestion } from './questionSagas';
import { fetchOneRedFlag, saveRedFlag, saveManyRedFlags, removeRedFlag, restoreRedFlag } from './redFlagSagas';
import { fetchOneRedFlagType, saveRedFlagType, saveManyRedFlagTypes, removeRedFlagType, restoreRedFlagType } from './redFlagTypeSagas';
import { fetchOneReferral, saveReferral, saveManyReferrals, removeReferral, restoreReferral } from './referralSagas';
import { fetchOneResource, saveResource, saveManyResources, removeResource, restoreResource } from './resourceSagas';
import { fetchOneRole, saveRole, saveManyRoles, removeRole, restoreRole } from './roleSagas';
import { fetchOneTask, saveTask, saveManyTasks, removeTask, restoreTask } from './taskSagas';
import { fetchOneTemplateTask, saveTemplateTask, saveManyTemplateTasks, removeTemplateTask, restoreTemplateTask } from './templateTaskSagas';
import { fetchOneTimeOff, saveTimeOff, saveManyTimeOffs, removeTimeOff, restoreTimeOff } from './timeOffSagas';
import { fetchOneTransaction, saveTransaction, saveManyTransactions, removeTransaction, restoreTransaction } from './transactionSagas';
import { fetchOneUser, saveUser, saveManyUsers, removeUser, restoreUser } from './userSagas';

import { ACCOUNTINGCONNECTION_FETCH_ONE_QUEUE, ACCOUNTINGCONNECTION_SAVE_QUEUE, ACCOUNTINGCONNECTION_SAVE_MANY_QUEUE, ACCOUNTINGCONNECTION_REMOVE_QUEUE, ACCOUNTINGCONNECTION_RESTORE_QUEUE } from '../actions/accountingConnectionActions';
import { ACTIVITYCATEGORY_FETCH_ONE_QUEUE, ACTIVITYCATEGORY_SAVE_QUEUE, ACTIVITYCATEGORY_SAVE_MANY_QUEUE, ACTIVITYCATEGORY_REMOVE_QUEUE, ACTIVITYCATEGORY_RESTORE_QUEUE } from '../actions/activityCategoryActions';
import { ACTIVITYTYPE_FETCH_ONE_QUEUE, ACTIVITYTYPE_SAVE_QUEUE, ACTIVITYTYPE_SAVE_MANY_QUEUE, ACTIVITYTYPE_REMOVE_QUEUE, ACTIVITYTYPE_RESTORE_QUEUE } from '../actions/activityTypeActions';
import { ADDRESS_FETCH_ONE_QUEUE, ADDRESS_SAVE_QUEUE, ADDRESS_SAVE_MANY_QUEUE, ADDRESS_REMOVE_QUEUE, ADDRESS_RESTORE_QUEUE } from '../actions/addressActions';
import { ANSWER_FETCH_ONE_QUEUE, ANSWER_SAVE_QUEUE, ANSWER_SAVE_MANY_QUEUE, ANSWER_REMOVE_QUEUE, ANSWER_RESTORE_QUEUE } from '../actions/answerActions';
import { BANKACCOUNT_FETCH_ONE_QUEUE, BANKACCOUNT_SAVE_QUEUE, BANKACCOUNT_SAVE_MANY_QUEUE, BANKACCOUNT_REMOVE_QUEUE, BANKACCOUNT_RESTORE_QUEUE } from '../actions/bankAccountActions';
import { BLACKOUT_FETCH_ONE_QUEUE, BLACKOUT_SAVE_QUEUE, BLACKOUT_SAVE_MANY_QUEUE, BLACKOUT_REMOVE_QUEUE, BLACKOUT_RESTORE_QUEUE } from '../actions/blackoutActions';
import { CAMPAIGN_FETCH_ONE_QUEUE, CAMPAIGN_SAVE_QUEUE, CAMPAIGN_SAVE_MANY_QUEUE, CAMPAIGN_REMOVE_QUEUE, CAMPAIGN_RESTORE_QUEUE } from '../actions/campaignActions';
import { CASETYPESTAGE_FETCH_ONE_QUEUE, CASETYPESTAGE_SAVE_QUEUE, CASETYPESTAGE_SAVE_MANY_QUEUE, CASETYPESTAGE_REMOVE_QUEUE, CASETYPESTAGE_RESTORE_QUEUE } from '../actions/caseTypeStageActions';
import { CASETYPE_FETCH_ONE_QUEUE, CASETYPE_SAVE_QUEUE, CASETYPE_SAVE_MANY_QUEUE, CASETYPE_REMOVE_QUEUE, CASETYPE_RESTORE_QUEUE } from '../actions/caseTypeActions';
import { CATEGORY_FETCH_ONE_QUEUE, CATEGORY_SAVE_QUEUE, CATEGORY_SAVE_MANY_QUEUE, CATEGORY_REMOVE_QUEUE, CATEGORY_RESTORE_QUEUE } from '../actions/categoryActions';
import { COMMENT_FETCH_ONE_QUEUE, COMMENT_SAVE_QUEUE, COMMENT_SAVE_MANY_QUEUE, COMMENT_REMOVE_QUEUE, COMMENT_RESTORE_QUEUE } from '../actions/commentActions';
import { CONFLICT_FETCH_ONE_QUEUE, CONFLICT_SAVE_QUEUE, CONFLICT_SAVE_MANY_QUEUE, CONFLICT_REMOVE_QUEUE, CONFLICT_RESTORE_QUEUE } from '../actions/conflictActions';
import { CONTACT_FETCH_ONE_QUEUE, CONTACT_SAVE_QUEUE, CONTACT_SAVE_MANY_QUEUE, CONTACT_REMOVE_QUEUE, CONTACT_RESTORE_QUEUE } from '../actions/contactActions';
import { COURTDEADLINERULE_FETCH_ONE_QUEUE, COURTDEADLINERULE_SAVE_QUEUE, COURTDEADLINERULE_SAVE_MANY_QUEUE, COURTDEADLINERULE_REMOVE_QUEUE, COURTDEADLINERULE_RESTORE_QUEUE } from '../actions/courtDeadlineRuleActions';
import { COURT_FETCH_ONE_QUEUE, COURT_SAVE_QUEUE, COURT_SAVE_MANY_QUEUE, COURT_REMOVE_QUEUE, COURT_RESTORE_QUEUE } from '../actions/courtActions';
import { DEADLINERULE_FETCH_ONE_QUEUE, DEADLINERULE_SAVE_QUEUE, DEADLINERULE_SAVE_MANY_QUEUE, DEADLINERULE_REMOVE_QUEUE, DEADLINERULE_RESTORE_QUEUE } from '../actions/deadlineRuleActions';
import { DEADLINE_FETCH_ONE_QUEUE, DEADLINE_SAVE_QUEUE, DEADLINE_SAVE_MANY_QUEUE, DEADLINE_REMOVE_QUEUE, DEADLINE_RESTORE_QUEUE } from '../actions/deadlineActions';
import { DISCOUNT_FETCH_ONE_QUEUE, DISCOUNT_SAVE_QUEUE, DISCOUNT_SAVE_MANY_QUEUE, DISCOUNT_REMOVE_QUEUE, DISCOUNT_RESTORE_QUEUE } from '../actions/discountActions';
import { DOCKET_FETCH_ONE_QUEUE, DOCKET_SAVE_QUEUE, DOCKET_SAVE_MANY_QUEUE, DOCKET_REMOVE_QUEUE, DOCKET_RESTORE_QUEUE } from '../actions/docketActions';
import { DOCUMENT_FETCH_ONE_QUEUE, DOCUMENT_SAVE_QUEUE, DOCUMENT_SAVE_MANY_QUEUE, DOCUMENT_REMOVE_QUEUE, DOCUMENT_RESTORE_QUEUE } from '../actions/documentActions';
import { ENTITYTIMESTAMP_FETCH_ONE_QUEUE, ENTITYTIMESTAMP_SAVE_QUEUE, ENTITYTIMESTAMP_SAVE_MANY_QUEUE, ENTITYTIMESTAMP_REMOVE_QUEUE, ENTITYTIMESTAMP_RESTORE_QUEUE } from '../actions/entityTimestampActions';
import { EVENT_FETCH_ONE_QUEUE, EVENT_SAVE_QUEUE, EVENT_SAVE_MANY_QUEUE, EVENT_REMOVE_QUEUE, EVENT_RESTORE_QUEUE } from '../actions/eventActions';
import { EXPENSE_FETCH_ONE_QUEUE, EXPENSE_SAVE_QUEUE, EXPENSE_SAVE_MANY_QUEUE, EXPENSE_REMOVE_QUEUE, EXPENSE_RESTORE_QUEUE } from '../actions/expenseActions';
import { FIRM_FETCH_ONE_QUEUE, FIRM_SAVE_QUEUE, FIRM_SAVE_MANY_QUEUE, FIRM_REMOVE_QUEUE, FIRM_RESTORE_QUEUE } from '../actions/firmActions';
import { FLATFEEMILESTONE_FETCH_ONE_QUEUE, FLATFEEMILESTONE_SAVE_QUEUE, FLATFEEMILESTONE_SAVE_MANY_QUEUE, FLATFEEMILESTONE_REMOVE_QUEUE, FLATFEEMILESTONE_RESTORE_QUEUE } from '../actions/flatFeeMilestoneActions';
import { FLATFEE_FETCH_ONE_QUEUE, FLATFEE_SAVE_QUEUE, FLATFEE_SAVE_MANY_QUEUE, FLATFEE_REMOVE_QUEUE, FLATFEE_RESTORE_QUEUE } from '../actions/flatFeeActions';
import { GROUP_FETCH_ONE_QUEUE, GROUP_SAVE_QUEUE, GROUP_SAVE_MANY_QUEUE, GROUP_REMOVE_QUEUE, GROUP_RESTORE_QUEUE } from '../actions/groupActions';
import { HOLIDAYCALENDAR_FETCH_ONE_QUEUE, HOLIDAYCALENDAR_SAVE_QUEUE, HOLIDAYCALENDAR_SAVE_MANY_QUEUE, HOLIDAYCALENDAR_REMOVE_QUEUE, HOLIDAYCALENDAR_RESTORE_QUEUE } from '../actions/holidayCalendarActions';
import { IDENTIFICATION_FETCH_ONE_QUEUE, IDENTIFICATION_SAVE_QUEUE, IDENTIFICATION_SAVE_MANY_QUEUE, IDENTIFICATION_REMOVE_QUEUE, IDENTIFICATION_RESTORE_QUEUE } from '../actions/identificationActions';
import { IMPORTEXPORT_FETCH_ONE_QUEUE, IMPORTEXPORT_SAVE_QUEUE, IMPORTEXPORT_SAVE_MANY_QUEUE, IMPORTEXPORT_REMOVE_QUEUE, IMPORTEXPORT_RESTORE_QUEUE } from '../actions/importExportActions';
import { IMPORTSOURCE_FETCH_ONE_QUEUE, IMPORTSOURCE_SAVE_QUEUE, IMPORTSOURCE_SAVE_MANY_QUEUE, IMPORTSOURCE_REMOVE_QUEUE, IMPORTSOURCE_RESTORE_QUEUE } from '../actions/importSourceActions';
import { INVOICEBATCHITEM_FETCH_ONE_QUEUE, INVOICEBATCHITEM_SAVE_QUEUE, INVOICEBATCHITEM_SAVE_MANY_QUEUE, INVOICEBATCHITEM_REMOVE_QUEUE, INVOICEBATCHITEM_RESTORE_QUEUE } from '../actions/invoiceBatchItemActions';
import { INVOICEBATCH_FETCH_ONE_QUEUE, INVOICEBATCH_SAVE_QUEUE, INVOICEBATCH_SAVE_MANY_QUEUE, INVOICEBATCH_REMOVE_QUEUE, INVOICEBATCH_RESTORE_QUEUE } from '../actions/invoiceBatchActions';
import { INVOICE_FETCH_ONE_QUEUE, INVOICE_SAVE_QUEUE, INVOICE_SAVE_MANY_QUEUE, INVOICE_REMOVE_QUEUE, INVOICE_RESTORE_QUEUE } from '../actions/invoiceActions';
import { LEAD_FETCH_ONE_QUEUE, LEAD_SAVE_QUEUE, LEAD_SAVE_MANY_QUEUE, LEAD_REMOVE_QUEUE, LEAD_RESTORE_QUEUE } from '../actions/leadActions';
import { LOOKUP_FETCH_ONE_QUEUE, LOOKUP_SAVE_QUEUE, LOOKUP_SAVE_MANY_QUEUE, LOOKUP_REMOVE_QUEUE, LOOKUP_RESTORE_QUEUE } from '../actions/lookupActions';
import { MATTERSTAGE_FETCH_ONE_QUEUE, MATTERSTAGE_SAVE_QUEUE, MATTERSTAGE_SAVE_MANY_QUEUE, MATTERSTAGE_REMOVE_QUEUE, MATTERSTAGE_RESTORE_QUEUE } from '../actions/matterStageActions';
import { MATTER_FETCH_ONE_QUEUE, MATTER_SAVE_QUEUE, MATTER_SAVE_MANY_QUEUE, MATTER_REMOVE_QUEUE, MATTER_RESTORE_QUEUE } from '../actions/matterActions';
import { MILESTONE_FETCH_ONE_QUEUE, MILESTONE_SAVE_QUEUE, MILESTONE_SAVE_MANY_QUEUE, MILESTONE_REMOVE_QUEUE, MILESTONE_RESTORE_QUEUE } from '../actions/milestoneActions';
import { OPTION_FETCH_ONE_QUEUE, OPTION_SAVE_QUEUE, OPTION_SAVE_MANY_QUEUE, OPTION_REMOVE_QUEUE, OPTION_RESTORE_QUEUE } from '../actions/optionActions';
import { PARTICIPANT_FETCH_ONE_QUEUE, PARTICIPANT_SAVE_QUEUE, PARTICIPANT_SAVE_MANY_QUEUE, PARTICIPANT_REMOVE_QUEUE, PARTICIPANT_RESTORE_QUEUE } from '../actions/participantActions';
import { PRIVILEGE_FETCH_ONE_QUEUE, PRIVILEGE_SAVE_QUEUE, PRIVILEGE_SAVE_MANY_QUEUE, PRIVILEGE_REMOVE_QUEUE, PRIVILEGE_RESTORE_QUEUE } from '../actions/privilegeActions';
import { QUESTION_FETCH_ONE_QUEUE, QUESTION_SAVE_QUEUE, QUESTION_SAVE_MANY_QUEUE, QUESTION_REMOVE_QUEUE, QUESTION_RESTORE_QUEUE } from '../actions/questionActions';
import { REDFLAGTYPE_FETCH_ONE_QUEUE, REDFLAGTYPE_SAVE_QUEUE, REDFLAGTYPE_SAVE_MANY_QUEUE, REDFLAGTYPE_REMOVE_QUEUE, REDFLAGTYPE_RESTORE_QUEUE } from '../actions/redFlagTypeActions';
import { REDFLAG_FETCH_ONE_QUEUE, REDFLAG_SAVE_QUEUE, REDFLAG_SAVE_MANY_QUEUE, REDFLAG_REMOVE_QUEUE, REDFLAG_RESTORE_QUEUE } from '../actions/redFlagActions';
import { REFERRAL_FETCH_ONE_QUEUE, REFERRAL_SAVE_QUEUE, REFERRAL_SAVE_MANY_QUEUE, REFERRAL_REMOVE_QUEUE, REFERRAL_RESTORE_QUEUE } from '../actions/referralActions';
import { RESOURCE_FETCH_ONE_QUEUE, RESOURCE_SAVE_QUEUE, RESOURCE_SAVE_MANY_QUEUE, RESOURCE_REMOVE_QUEUE, RESOURCE_RESTORE_QUEUE } from '../actions/resourceActions';
import { ROLE_FETCH_ONE_QUEUE, ROLE_SAVE_QUEUE, ROLE_SAVE_MANY_QUEUE, ROLE_REMOVE_QUEUE, ROLE_RESTORE_QUEUE } from '../actions/roleActions';
import { TASK_FETCH_ONE_QUEUE, TASK_SAVE_QUEUE, TASK_SAVE_MANY_QUEUE, TASK_REMOVE_QUEUE, TASK_RESTORE_QUEUE } from '../actions/taskActions';
import { TEMPLATETASK_FETCH_ONE_QUEUE, TEMPLATETASK_SAVE_QUEUE, TEMPLATETASK_SAVE_MANY_QUEUE, TEMPLATETASK_REMOVE_QUEUE, TEMPLATETASK_RESTORE_QUEUE } from '../actions/templateTaskActions';
import { TIMEOFF_FETCH_ONE_QUEUE, TIMEOFF_SAVE_QUEUE, TIMEOFF_SAVE_MANY_QUEUE, TIMEOFF_REMOVE_QUEUE, TIMEOFF_RESTORE_QUEUE } from '../actions/timeOffActions';
import { TRANSACTION_FETCH_ONE_QUEUE, TRANSACTION_SAVE_QUEUE, TRANSACTION_SAVE_MANY_QUEUE, TRANSACTION_REMOVE_QUEUE, TRANSACTION_RESTORE_QUEUE } from '../actions/transactionActions';
import { USER_FETCH_ONE_QUEUE, USER_SAVE_QUEUE, USER_SAVE_MANY_QUEUE, USER_REMOVE_QUEUE, USER_RESTORE_QUEUE } from '../actions/userActions';

import { takeEvery } from 'redux-saga/effects';

export function* watchAll() {

	yield takeEvery(ACCOUNTINGCONNECTION_FETCH_ONE_QUEUE, fetchOneAccountingConnection);
	yield takeEvery(ACCOUNTINGCONNECTION_SAVE_QUEUE, saveAccountingConnection);
	yield takeEvery(ACCOUNTINGCONNECTION_SAVE_MANY_QUEUE, saveManyAccountingConnections);
	yield takeEvery(ACCOUNTINGCONNECTION_REMOVE_QUEUE, removeAccountingConnection);
	yield takeEvery(ACCOUNTINGCONNECTION_RESTORE_QUEUE, restoreAccountingConnection);

	yield takeEvery(ACTIVITYCATEGORY_FETCH_ONE_QUEUE, fetchOneActivityCategory);
	yield takeEvery(ACTIVITYCATEGORY_SAVE_QUEUE, saveActivityCategory);
	yield takeEvery(ACTIVITYCATEGORY_SAVE_MANY_QUEUE, saveManyActivityCategories);
	yield takeEvery(ACTIVITYCATEGORY_REMOVE_QUEUE, removeActivityCategory);
	yield takeEvery(ACTIVITYCATEGORY_RESTORE_QUEUE, restoreActivityCategory);

	yield takeEvery(ACTIVITYTYPE_FETCH_ONE_QUEUE, fetchOneActivityType);
	yield takeEvery(ACTIVITYTYPE_SAVE_QUEUE, saveActivityType);
	yield takeEvery(ACTIVITYTYPE_SAVE_MANY_QUEUE, saveManyActivityTypes);
	yield takeEvery(ACTIVITYTYPE_REMOVE_QUEUE, removeActivityType);
	yield takeEvery(ACTIVITYTYPE_RESTORE_QUEUE, restoreActivityType);

	yield takeEvery(ADDRESS_FETCH_ONE_QUEUE, fetchOneAddress);
	yield takeEvery(ADDRESS_SAVE_QUEUE, saveAddress);
	yield takeEvery(ADDRESS_SAVE_MANY_QUEUE, saveManyAddresses);
	yield takeEvery(ADDRESS_REMOVE_QUEUE, removeAddress);
	yield takeEvery(ADDRESS_RESTORE_QUEUE, restoreAddress);

	yield takeEvery(ANSWER_FETCH_ONE_QUEUE, fetchOneAnswer);
	yield takeEvery(ANSWER_SAVE_QUEUE, saveAnswer);
	yield takeEvery(ANSWER_SAVE_MANY_QUEUE, saveManyAnswers);
	yield takeEvery(ANSWER_REMOVE_QUEUE, removeAnswer);
	yield takeEvery(ANSWER_RESTORE_QUEUE, restoreAnswer);

	yield takeEvery(BANKACCOUNT_FETCH_ONE_QUEUE, fetchOneBankAccount);
	yield takeEvery(BANKACCOUNT_SAVE_QUEUE, saveBankAccount);
	yield takeEvery(BANKACCOUNT_SAVE_MANY_QUEUE, saveManyBankAccounts);
	yield takeEvery(BANKACCOUNT_REMOVE_QUEUE, removeBankAccount);
	yield takeEvery(BANKACCOUNT_RESTORE_QUEUE, restoreBankAccount);

	yield takeEvery(BLACKOUT_FETCH_ONE_QUEUE, fetchOneBlackout);
	yield takeEvery(BLACKOUT_SAVE_QUEUE, saveBlackout);
	yield takeEvery(BLACKOUT_SAVE_MANY_QUEUE, saveManyBlackouts);
	yield takeEvery(BLACKOUT_REMOVE_QUEUE, removeBlackout);
	yield takeEvery(BLACKOUT_RESTORE_QUEUE, restoreBlackout);

	yield takeEvery(CATEGORY_FETCH_ONE_QUEUE, fetchOneCategory);
	yield takeEvery(CATEGORY_SAVE_QUEUE, saveCategory);
	yield takeEvery(CATEGORY_SAVE_MANY_QUEUE, saveManyCategories);
	yield takeEvery(CATEGORY_REMOVE_QUEUE, removeCategory);
	yield takeEvery(CATEGORY_RESTORE_QUEUE, restoreCategory);

	yield takeEvery(CAMPAIGN_FETCH_ONE_QUEUE, fetchOneCampaign);
	yield takeEvery(CAMPAIGN_SAVE_QUEUE, saveCampaign);
	yield takeEvery(CAMPAIGN_SAVE_MANY_QUEUE, saveManyCampaigns);
	yield takeEvery(CAMPAIGN_REMOVE_QUEUE, removeCampaign);
	yield takeEvery(CAMPAIGN_RESTORE_QUEUE, restoreCampaign);

	yield takeEvery(DOCKET_FETCH_ONE_QUEUE, fetchOneDocket);
	yield takeEvery(DOCKET_SAVE_QUEUE, saveDocket);
	yield takeEvery(DOCKET_SAVE_MANY_QUEUE, saveManyDockets);
	yield takeEvery(DOCKET_REMOVE_QUEUE, removeDocket);
	yield takeEvery(DOCKET_RESTORE_QUEUE, restoreDocket);

	yield takeEvery(MATTER_FETCH_ONE_QUEUE, fetchOneMatter);
	yield takeEvery(MATTER_SAVE_QUEUE, saveMatter);
	yield takeEvery(MATTER_SAVE_MANY_QUEUE, saveManyMatters);
	yield takeEvery(MATTER_REMOVE_QUEUE, removeMatter);
	yield takeEvery(MATTER_RESTORE_QUEUE, restoreMatter);

	yield takeEvery(COMMENT_FETCH_ONE_QUEUE, fetchOneComment);
	yield takeEvery(COMMENT_SAVE_QUEUE, saveComment);
	yield takeEvery(COMMENT_SAVE_MANY_QUEUE, saveManyComments);
	yield takeEvery(COMMENT_REMOVE_QUEUE, removeComment);
	yield takeEvery(COMMENT_RESTORE_QUEUE, restoreComment);

	yield takeEvery(CASETYPE_FETCH_ONE_QUEUE, fetchOneCaseType);
	yield takeEvery(CASETYPE_SAVE_QUEUE, saveCaseType);
	yield takeEvery(CASETYPE_SAVE_MANY_QUEUE, saveManyCaseTypes);
	yield takeEvery(CASETYPE_REMOVE_QUEUE, removeCaseType);
	yield takeEvery(CASETYPE_RESTORE_QUEUE, restoreCaseType);

	yield takeEvery(CASETYPESTAGE_FETCH_ONE_QUEUE, fetchOneCaseTypeStage);
	yield takeEvery(CASETYPESTAGE_SAVE_QUEUE, saveCaseTypeStage);
	yield takeEvery(CASETYPESTAGE_SAVE_MANY_QUEUE, saveManyCaseTypeStages);
	yield takeEvery(CASETYPESTAGE_REMOVE_QUEUE, removeCaseTypeStage);
	yield takeEvery(CASETYPESTAGE_RESTORE_QUEUE, restoreCaseTypeStage);

	yield takeEvery(DEADLINE_FETCH_ONE_QUEUE, fetchOneDeadline);
	yield takeEvery(DEADLINE_SAVE_QUEUE, saveDeadline);
	yield takeEvery(DEADLINE_SAVE_MANY_QUEUE, saveManyDeadlines);
	yield takeEvery(DEADLINE_REMOVE_QUEUE, removeDeadline);
	yield takeEvery(DEADLINE_RESTORE_QUEUE, restoreDeadline);

	yield takeEvery(DEADLINERULE_FETCH_ONE_QUEUE, fetchOneDeadlineRule);
	yield takeEvery(DEADLINERULE_SAVE_QUEUE, saveDeadlineRule);
	yield takeEvery(DEADLINERULE_SAVE_MANY_QUEUE, saveManyDeadlineRules);
	yield takeEvery(DEADLINERULE_REMOVE_QUEUE, removeDeadlineRule);
	yield takeEvery(DEADLINERULE_RESTORE_QUEUE, restoreDeadlineRule);

	yield takeEvery(CONFLICT_FETCH_ONE_QUEUE, fetchOneConflict);
	yield takeEvery(CONFLICT_SAVE_QUEUE, saveConflict);
	yield takeEvery(CONFLICT_SAVE_MANY_QUEUE, saveManyConflicts);
	yield takeEvery(CONFLICT_REMOVE_QUEUE, removeConflict);
	yield takeEvery(CONFLICT_RESTORE_QUEUE, restoreConflict);

	yield takeEvery(CONTACT_FETCH_ONE_QUEUE, fetchOneContact);
	yield takeEvery(CONTACT_SAVE_QUEUE, saveContact);
	yield takeEvery(CONTACT_SAVE_MANY_QUEUE, saveManyContacts);
	yield takeEvery(CONTACT_REMOVE_QUEUE, removeContact);
	yield takeEvery(CONTACT_RESTORE_QUEUE, restoreContact);

	yield takeEvery(COURT_FETCH_ONE_QUEUE, fetchOneCourt);
	yield takeEvery(COURT_SAVE_QUEUE, saveCourt);
	yield takeEvery(COURT_SAVE_MANY_QUEUE, saveManyCourts);
	yield takeEvery(COURT_REMOVE_QUEUE, removeCourt);
	yield takeEvery(COURT_RESTORE_QUEUE, restoreCourt);

	yield takeEvery(COURTDEADLINERULE_FETCH_ONE_QUEUE, fetchOneCourtDeadlineRule);
	yield takeEvery(COURTDEADLINERULE_SAVE_QUEUE, saveCourtDeadlineRule);
	yield takeEvery(COURTDEADLINERULE_SAVE_MANY_QUEUE, saveManyCourtDeadlineRules);
	yield takeEvery(COURTDEADLINERULE_REMOVE_QUEUE, removeCourtDeadlineRule);
	yield takeEvery(COURTDEADLINERULE_RESTORE_QUEUE, restoreCourtDeadlineRule);

	yield takeEvery(DISCOUNT_FETCH_ONE_QUEUE, fetchOneDiscount);
	yield takeEvery(DISCOUNT_SAVE_QUEUE, saveDiscount);
	yield takeEvery(DISCOUNT_SAVE_MANY_QUEUE, saveManyDiscounts);
	yield takeEvery(DISCOUNT_REMOVE_QUEUE, removeDiscount);
	yield takeEvery(DISCOUNT_RESTORE_QUEUE, restoreDiscount);

	yield takeEvery(ENTITYTIMESTAMP_FETCH_ONE_QUEUE, fetchOneEntityTimestamp);
	yield takeEvery(ENTITYTIMESTAMP_SAVE_QUEUE, saveEntityTimestamp);
	yield takeEvery(ENTITYTIMESTAMP_SAVE_MANY_QUEUE, saveManyEntityTimestamps);
	yield takeEvery(ENTITYTIMESTAMP_REMOVE_QUEUE, removeEntityTimestamp);
	yield takeEvery(ENTITYTIMESTAMP_RESTORE_QUEUE, restoreEntityTimestamp);

	yield takeEvery(DOCUMENT_FETCH_ONE_QUEUE, fetchOneDocument);
	yield takeEvery(DOCUMENT_SAVE_QUEUE, saveDocument);
	yield takeEvery(DOCUMENT_SAVE_MANY_QUEUE, saveManyDocuments);
	yield takeEvery(DOCUMENT_REMOVE_QUEUE, removeDocument);
	yield takeEvery(DOCUMENT_RESTORE_QUEUE, restoreDocument);

	yield takeEvery(EXPENSE_FETCH_ONE_QUEUE, fetchOneExpense);
	yield takeEvery(EXPENSE_SAVE_QUEUE, saveExpense);
	yield takeEvery(EXPENSE_SAVE_MANY_QUEUE, saveManyExpenses);
	yield takeEvery(EXPENSE_REMOVE_QUEUE, removeExpense);
	yield takeEvery(EXPENSE_RESTORE_QUEUE, restoreExpense);

	yield takeEvery(EVENT_FETCH_ONE_QUEUE, fetchOneEvent);
	yield takeEvery(EVENT_SAVE_QUEUE, saveEvent);
	yield takeEvery(EVENT_SAVE_MANY_QUEUE, saveManyEvents);
	yield takeEvery(EVENT_REMOVE_QUEUE, removeEvent);
	yield takeEvery(EVENT_RESTORE_QUEUE, restoreEvent);

	yield takeEvery(FIRM_FETCH_ONE_QUEUE, fetchOneFirm);
	yield takeEvery(FIRM_SAVE_QUEUE, saveFirm);
	yield takeEvery(FIRM_SAVE_MANY_QUEUE, saveManyFirms);
	yield takeEvery(FIRM_REMOVE_QUEUE, removeFirm);
	yield takeEvery(FIRM_RESTORE_QUEUE, restoreFirm);

	yield takeEvery(FLATFEE_FETCH_ONE_QUEUE, fetchOneFlatFee);
	yield takeEvery(FLATFEE_SAVE_QUEUE, saveFlatFee);
	yield takeEvery(FLATFEE_SAVE_MANY_QUEUE, saveManyFlatFees);
	yield takeEvery(FLATFEE_REMOVE_QUEUE, removeFlatFee);
	yield takeEvery(FLATFEE_RESTORE_QUEUE, restoreFlatFee);

	yield takeEvery(FLATFEEMILESTONE_FETCH_ONE_QUEUE, fetchOneFlatFeeMilestone);
	yield takeEvery(FLATFEEMILESTONE_SAVE_QUEUE, saveFlatFeeMilestone);
	yield takeEvery(FLATFEEMILESTONE_SAVE_MANY_QUEUE, saveManyFlatFeeMilestones);
	yield takeEvery(FLATFEEMILESTONE_REMOVE_QUEUE, removeFlatFeeMilestone);
	yield takeEvery(FLATFEEMILESTONE_RESTORE_QUEUE, restoreFlatFeeMilestone);

	yield takeEvery(GROUP_FETCH_ONE_QUEUE, fetchOneGroup);
	yield takeEvery(GROUP_SAVE_QUEUE, saveGroup);
	yield takeEvery(GROUP_SAVE_MANY_QUEUE, saveManyGroups);
	yield takeEvery(GROUP_REMOVE_QUEUE, removeGroup);
	yield takeEvery(GROUP_RESTORE_QUEUE, restoreGroup);

	yield takeEvery(HOLIDAYCALENDAR_FETCH_ONE_QUEUE, fetchOneHolidayCalendar);
	yield takeEvery(HOLIDAYCALENDAR_SAVE_QUEUE, saveHolidayCalendar);
	yield takeEvery(HOLIDAYCALENDAR_SAVE_MANY_QUEUE, saveManyHolidayCalendars);
	yield takeEvery(HOLIDAYCALENDAR_REMOVE_QUEUE, removeHolidayCalendar);
	yield takeEvery(HOLIDAYCALENDAR_RESTORE_QUEUE, restoreHolidayCalendar);

	yield takeEvery(IDENTIFICATION_FETCH_ONE_QUEUE, fetchOneIdentification);
	yield takeEvery(IDENTIFICATION_SAVE_QUEUE, saveIdentification);
	yield takeEvery(IDENTIFICATION_SAVE_MANY_QUEUE, saveManyIdentifications);
	yield takeEvery(IDENTIFICATION_REMOVE_QUEUE, removeIdentification);
	yield takeEvery(IDENTIFICATION_RESTORE_QUEUE, restoreIdentification);

	yield takeEvery(IMPORTEXPORT_FETCH_ONE_QUEUE, fetchOneImportExport);
	yield takeEvery(IMPORTEXPORT_SAVE_QUEUE, saveImportExport);
	yield takeEvery(IMPORTEXPORT_SAVE_MANY_QUEUE, saveManyImportExports);
	yield takeEvery(IMPORTEXPORT_REMOVE_QUEUE, removeImportExport);
	yield takeEvery(IMPORTEXPORT_RESTORE_QUEUE, restoreImportExport);

	yield takeEvery(IMPORTSOURCE_FETCH_ONE_QUEUE, fetchOneImportSource);
	yield takeEvery(IMPORTSOURCE_SAVE_QUEUE, saveImportSource);
	yield takeEvery(IMPORTSOURCE_SAVE_MANY_QUEUE, saveManyImportSources);
	yield takeEvery(IMPORTSOURCE_REMOVE_QUEUE, removeImportSource);
	yield takeEvery(IMPORTSOURCE_RESTORE_QUEUE, restoreImportSource);

	yield takeEvery(INVOICE_FETCH_ONE_QUEUE, fetchOneInvoice);
	yield takeEvery(INVOICE_SAVE_QUEUE, saveInvoice);
	yield takeEvery(INVOICE_SAVE_MANY_QUEUE, saveManyInvoices);
	yield takeEvery(INVOICE_REMOVE_QUEUE, removeInvoice);
	yield takeEvery(INVOICE_RESTORE_QUEUE, restoreInvoice);

	yield takeEvery(INVOICEBATCH_FETCH_ONE_QUEUE, fetchOneInvoiceBatch);
	yield takeEvery(INVOICEBATCH_SAVE_QUEUE, saveInvoiceBatch);
	yield takeEvery(INVOICEBATCH_SAVE_MANY_QUEUE, saveManyInvoiceBatches);
	yield takeEvery(INVOICEBATCH_REMOVE_QUEUE, removeInvoiceBatch);
	yield takeEvery(INVOICEBATCH_RESTORE_QUEUE, restoreInvoiceBatch);

	yield takeEvery(INVOICEBATCHITEM_FETCH_ONE_QUEUE, fetchOneInvoiceBatchItem);
	yield takeEvery(INVOICEBATCHITEM_SAVE_QUEUE, saveInvoiceBatchItem);
	yield takeEvery(INVOICEBATCHITEM_SAVE_MANY_QUEUE, saveManyInvoiceBatchItems);
	yield takeEvery(INVOICEBATCHITEM_REMOVE_QUEUE, removeInvoiceBatchItem);
	yield takeEvery(INVOICEBATCHITEM_RESTORE_QUEUE, restoreInvoiceBatchItem);

	yield takeEvery(LEAD_FETCH_ONE_QUEUE, fetchOneLead);
	yield takeEvery(LEAD_SAVE_QUEUE, saveLead);
	yield takeEvery(LEAD_SAVE_MANY_QUEUE, saveManyLeads);
	yield takeEvery(LEAD_REMOVE_QUEUE, removeLead);
	yield takeEvery(LEAD_RESTORE_QUEUE, restoreLead);

	yield takeEvery(LOOKUP_FETCH_ONE_QUEUE, fetchOneLookup);
	yield takeEvery(LOOKUP_SAVE_QUEUE, saveLookup);
	yield takeEvery(LOOKUP_SAVE_MANY_QUEUE, saveManyLookups);
	yield takeEvery(LOOKUP_REMOVE_QUEUE, removeLookup);
	yield takeEvery(LOOKUP_RESTORE_QUEUE, restoreLookup);

	yield takeEvery(MATTERSTAGE_FETCH_ONE_QUEUE, fetchOneMatterStage);
	yield takeEvery(MATTERSTAGE_SAVE_QUEUE, saveMatterStage);
	yield takeEvery(MATTERSTAGE_SAVE_MANY_QUEUE, saveManyMatterStages);
	yield takeEvery(MATTERSTAGE_REMOVE_QUEUE, removeMatterStage);
	yield takeEvery(MATTERSTAGE_RESTORE_QUEUE, restoreMatterStage);

	yield takeEvery(MILESTONE_FETCH_ONE_QUEUE, fetchOneMilestone);
	yield takeEvery(MILESTONE_SAVE_QUEUE, saveMilestone);
	yield takeEvery(MILESTONE_SAVE_MANY_QUEUE, saveManyMilestones);
	yield takeEvery(MILESTONE_REMOVE_QUEUE, removeMilestone);
	yield takeEvery(MILESTONE_RESTORE_QUEUE, restoreMilestone);

	yield takeEvery(OPTION_FETCH_ONE_QUEUE, fetchOneOption);
	yield takeEvery(OPTION_SAVE_QUEUE, saveOption);
	yield takeEvery(OPTION_SAVE_MANY_QUEUE, saveManyOptions);
	yield takeEvery(OPTION_REMOVE_QUEUE, removeOption);
	yield takeEvery(OPTION_RESTORE_QUEUE, restoreOption);

	yield takeEvery(PARTICIPANT_FETCH_ONE_QUEUE, fetchOneParticipant);
	yield takeEvery(PARTICIPANT_SAVE_QUEUE, saveParticipant);
	yield takeEvery(PARTICIPANT_SAVE_MANY_QUEUE, saveManyParticipants);
	yield takeEvery(PARTICIPANT_REMOVE_QUEUE, removeParticipant);
	yield takeEvery(PARTICIPANT_RESTORE_QUEUE, restoreParticipant);

	yield takeEvery(PRIVILEGE_FETCH_ONE_QUEUE, fetchOnePrivilege);
	yield takeEvery(PRIVILEGE_SAVE_QUEUE, savePrivilege);
	yield takeEvery(PRIVILEGE_SAVE_MANY_QUEUE, saveManyPrivileges);
	yield takeEvery(PRIVILEGE_REMOVE_QUEUE, removePrivilege);
	yield takeEvery(PRIVILEGE_RESTORE_QUEUE, restorePrivilege);

	yield takeEvery(QUESTION_FETCH_ONE_QUEUE, fetchOneQuestion);
	yield takeEvery(QUESTION_SAVE_QUEUE, saveQuestion);
	yield takeEvery(QUESTION_SAVE_MANY_QUEUE, saveManyQuestions);
	yield takeEvery(QUESTION_REMOVE_QUEUE, removeQuestion);
	yield takeEvery(QUESTION_RESTORE_QUEUE, restoreQuestion);

	yield takeEvery(REDFLAGTYPE_FETCH_ONE_QUEUE, fetchOneRedFlagType);
	yield takeEvery(REDFLAGTYPE_SAVE_QUEUE, saveRedFlagType);
	yield takeEvery(REDFLAGTYPE_SAVE_MANY_QUEUE, saveManyRedFlagTypes);
	yield takeEvery(REDFLAGTYPE_REMOVE_QUEUE, removeRedFlagType);
	yield takeEvery(REDFLAGTYPE_RESTORE_QUEUE, restoreRedFlagType);

	yield takeEvery(REDFLAG_FETCH_ONE_QUEUE, fetchOneRedFlag);
	yield takeEvery(REDFLAG_SAVE_QUEUE, saveRedFlag);
	yield takeEvery(REDFLAG_SAVE_MANY_QUEUE, saveManyRedFlags);
	yield takeEvery(REDFLAG_REMOVE_QUEUE, removeRedFlag);
	yield takeEvery(REDFLAG_RESTORE_QUEUE, restoreRedFlag);

	yield takeEvery(RESOURCE_FETCH_ONE_QUEUE, fetchOneResource);
	yield takeEvery(RESOURCE_SAVE_QUEUE, saveResource);
	yield takeEvery(RESOURCE_SAVE_MANY_QUEUE, saveManyResources);
	yield takeEvery(RESOURCE_REMOVE_QUEUE, removeResource);
	yield takeEvery(RESOURCE_RESTORE_QUEUE, restoreResource);

	yield takeEvery(REFERRAL_FETCH_ONE_QUEUE, fetchOneReferral);
	yield takeEvery(REFERRAL_SAVE_QUEUE, saveReferral);
	yield takeEvery(REFERRAL_SAVE_MANY_QUEUE, saveManyReferrals);
	yield takeEvery(REFERRAL_REMOVE_QUEUE, removeReferral);
	yield takeEvery(REFERRAL_RESTORE_QUEUE, restoreReferral);

	yield takeEvery(ROLE_FETCH_ONE_QUEUE, fetchOneRole);
	yield takeEvery(ROLE_SAVE_QUEUE, saveRole);
	yield takeEvery(ROLE_SAVE_MANY_QUEUE, saveManyRoles);
	yield takeEvery(ROLE_REMOVE_QUEUE, removeRole);
	yield takeEvery(ROLE_RESTORE_QUEUE, restoreRole);

	yield takeEvery(TASK_FETCH_ONE_QUEUE, fetchOneTask);
	yield takeEvery(TASK_SAVE_QUEUE, saveTask);
	yield takeEvery(TASK_SAVE_MANY_QUEUE, saveManyTasks);
	yield takeEvery(TASK_REMOVE_QUEUE, removeTask);
	yield takeEvery(TASK_RESTORE_QUEUE, restoreTask);

	yield takeEvery(TEMPLATETASK_FETCH_ONE_QUEUE, fetchOneTemplateTask);
	yield takeEvery(TEMPLATETASK_SAVE_QUEUE, saveTemplateTask);
	yield takeEvery(TEMPLATETASK_SAVE_MANY_QUEUE, saveManyTemplateTasks);
	yield takeEvery(TEMPLATETASK_REMOVE_QUEUE, removeTemplateTask);
	yield takeEvery(TEMPLATETASK_RESTORE_QUEUE, restoreTemplateTask);

	yield takeEvery(TIMEOFF_FETCH_ONE_QUEUE, fetchOneTimeOff);
	yield takeEvery(TIMEOFF_SAVE_QUEUE, saveTimeOff);
	yield takeEvery(TIMEOFF_SAVE_MANY_QUEUE, saveManyTimeOffs);
	yield takeEvery(TIMEOFF_REMOVE_QUEUE, removeTimeOff);
	yield takeEvery(TIMEOFF_RESTORE_QUEUE, restoreTimeOff);

	yield takeEvery(TRANSACTION_FETCH_ONE_QUEUE, fetchOneTransaction);
	yield takeEvery(TRANSACTION_SAVE_QUEUE, saveTransaction);
	yield takeEvery(TRANSACTION_SAVE_MANY_QUEUE, saveManyTransactions);
	yield takeEvery(TRANSACTION_REMOVE_QUEUE, removeTransaction);
	yield takeEvery(TRANSACTION_RESTORE_QUEUE, restoreTransaction);

	yield takeEvery(USER_FETCH_ONE_QUEUE, fetchOneUser);
	yield takeEvery(USER_SAVE_QUEUE, saveUser);
	yield takeEvery(USER_SAVE_MANY_QUEUE, saveManyUsers);
	yield takeEvery(USER_REMOVE_QUEUE, removeUser);
	yield takeEvery(USER_RESTORE_QUEUE, restoreUser);
}